export const AccountCircle = () => (
  <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.0607 3.39368C10.8607 3.39368 3.39404 10.8603 3.39404 20.0603C3.39404 29.2603 10.8607 36.727 20.0607 36.727C29.2607 36.727 36.7274 29.2603 36.7274 20.0603C36.7274 10.8603 29.2607 3.39368 20.0607 3.39368ZM20.0607 8.39368C22.8274 8.39368 25.0607 10.627 25.0607 13.3937C25.0607 16.1603 22.8274 18.3937 20.0607 18.3937C17.294 18.3937 15.0607 16.1603 15.0607 13.3937C15.0607 10.627 17.294 8.39368 20.0607 8.39368ZM20.0607 32.0603C15.894 32.0603 12.2107 29.927 10.0607 26.6937C10.1107 23.377 16.7274 21.5603 20.0607 21.5603C23.3774 21.5603 30.0107 23.377 30.0607 26.6937C27.9107 29.927 24.2274 32.0603 20.0607 32.0603Z"
      fill="#BBD0FB"
    />
  </svg>
);
